import {  POST } from "../../helper/xbi4RestFunctions";
export const createGoals = async (org_id: any, data: any, orgUserId: any) => {
  const path = `/orgs/${org_id}/users/${orgUserId}/projects/goals`;
  return await POST(path, data)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};
